// extracted by mini-css-extract-plugin
module.exports = {"sponsored-icon":"sponsored-m__sponsored-icon__nAFR0"};